<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import SpecificationTag from './SpecificationTag.svelte';
  const dispatch = createEventDispatcher();

  export let data;
  export let containerClass = '';
  let variantData;
  let oosClass = '';

  $: if (data) {
    variantData = data;
    oosClass = data?.variantOption?.stock?.stockLevelStatus?.code;
  }

  function handleClick() {
    dispatch('click', data);
  }
</script>

{#if variantData}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class={`${containerClass} ${oosClass}`} on:click={handleClick}>
    <SpecificationTag {...variantData} />
  </div>
{/if}
